let isMobileLayout = false;
let originalOrder: HTMLElement[] = [];
const MOBILE_BREAKPOINT = 1279;

function rearrangeHeadBasedOnViewport() {
    const wrapper = document.querySelector('.head-wrapper.newnav');
    if (!wrapper) return;

    // Einmal beim Start die Original-Reihenfolge speichern
    if (originalOrder.length === 0) {
        originalOrder = Array.from(wrapper.children) as HTMLElement[];
    }

    const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

    // Wenn wir in die Mobile-Ansicht wechseln und noch nicht umsortiert haben
    if (isMobile && !isMobileLayout) {
        const logo = wrapper.querySelector('.head-logo');
        const nav = wrapper.querySelector('.head-nav');
        const tools = wrapper.querySelector('.head-tools');
        const toggle = wrapper.querySelector('.head-sticky-toggle');
        const search = wrapper.querySelector('.head-search-wrapper-c');

        if (logo && nav && tools && toggle && search) {
            // Leeren und neue Reihenfolge einfügen
            while (wrapper.firstChild) wrapper.removeChild(wrapper.firstChild);
            wrapper.append(nav, logo, tools, toggle, search);
            isMobileLayout = true;
        }
    }

    // Wenn wir zurück auf Desktop wechseln und vorher mobil umsortiert hatten
    if (!isMobile && isMobileLayout) {
        while (wrapper.firstChild) wrapper.removeChild(wrapper.firstChild);
        originalOrder.forEach(el => wrapper.appendChild(el));
        isMobileLayout = false;
    }
}

window.addEventListener('DOMContentLoaded', rearrangeHeadBasedOnViewport);
window.addEventListener('resize', rearrangeHeadBasedOnViewport);
